import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportEmployeeEmissionsList from '@/pages/report-employee-emissions-list/ReportEmployeeEmissionsList'

export default {
  path: '/report-employee-emissions',
  name: 'ReportEmployeeEmissionsList',
  components: {
    mainContent: ReportEmployeeEmissionsList,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'report-employee-emissions'
    },
    breadcrumb: {
      title: 'Fechamento Fiscal/PDV',
      paths: [
        { title: 'Relatórios' },
      ]
    }
  }
}